import React from "react";
import "./Privacy.css";
import PageSEO from '../components/PageSEO';

function Privacy() {
  return (
    <>
    <PageSEO page="privacy" />
    <div className="policy-page">
      <section className="policy-hero">
        <h1>Privacy Policy</h1>
        <p>Last updated: June 1, 2026</p>
      </section>

      <div className="policy-body">
        <section className="policy-section">
          <h2>1. Introduction</h2>
          <p>
            Keystone Insurance Brokers Ltd ("we," "our," or "us") is committed to protecting your
            personal information and your right to privacy. This Privacy Policy explains how we
            collect, use, disclose, and safeguard your information when you visit our website or
            engage our services. Please read this policy carefully. If you disagree with its terms,
            please discontinue use of our site.
          </p>
        </section>

        <section className="policy-section">
          <h2>2. Information We Collect</h2>
          <p>We may collect the following types of personal information:</p>
          <ul>
            <li><strong>Contact Information:</strong> Name, email address, phone number, and mailing address.</li>
            <li><strong>Insurance Information:</strong> Details about your vehicle, property, business, or other insurable interests.</li>
            <li><strong>Financial Information:</strong> Information required to process quotes and premiums.</li>
            <li><strong>Usage Data:</strong> Browser type, IP address, pages visited, and time spent on our website.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>3. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide, operate, and maintain our insurance brokerage services.</li>
            <li>Process insurance quotes and policy applications on your behalf.</li>
            <li>Communicate with you about your policies, renewals, and claims.</li>
            <li>Comply with legal and regulatory obligations under applicable Canadian law.</li>
            <li>Improve our website and customer service experience.</li>
            <li>Send periodic emails or updates if you have opted in to receive them.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>4. Sharing Your Information</h2>
          <p>
            We do not sell, trade, or rent your personal information to third parties. We may share
            your information with:
          </p>
          <ul>
            <li><strong>Insurance Carriers:</strong> To obtain quotes or bind coverage on your behalf.</li>
            <li><strong>Regulatory Authorities:</strong> As required by the Insurance Council of British Columbia or other applicable regulators.</li>
            <li><strong>Service Providers:</strong> Trusted third parties who assist us in operating our website and conducting our business, under strict confidentiality agreements.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>5. Cookies & Tracking Technologies</h2>
          <p>
            Our website may use cookies and similar tracking technologies to enhance your browsing
            experience. You can instruct your browser to refuse all cookies or to indicate when a
            cookie is being sent. However, some features of our website may not function properly
            without cookies.
          </p>
        </section>

        <section className="policy-section">
          <h2>6. Data Security</h2>
          <p>
            We implement appropriate technical and organizational security measures to protect your
            personal information from unauthorized access, alteration, disclosure, or destruction.
            However, no method of transmission over the Internet is 100% secure, and we cannot
            guarantee absolute security.
          </p>
        </section>

        <section className="policy-section">
          <h2>7. Your Rights (PIPEDA)</h2>
          <p>
            Under Canada's Personal Information Protection and Electronic Documents Act (PIPEDA),
            you have the right to:
          </p>
          <ul>
            <li>Access the personal information we hold about you.</li>
            <li>Request correction of inaccurate or incomplete information.</li>
            <li>Withdraw consent for the use of your personal information (subject to legal limitations).</li>
            <li>File a complaint with the Office of the Privacy Commissioner of Canada.</li>
          </ul>
          <p>
            To exercise any of these rights, please contact us at{" "}
            <a href="mailto:Keystoneins@shaw.ca">Keystoneins@shaw.ca</a>.
          </p>
        </section>

        <section className="policy-section">
          <h2>8. Third-Party Links</h2>
          <p>
            Our website may contain links to third-party websites. We have no control over the
            content or privacy practices of those sites and encourage you to review their privacy
            policies independently.
          </p>
        </section>

        <section className="policy-section">
          <h2>9. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any changes
            by posting the new policy on this page with an updated effective date. Your continued
            use of our website after any changes constitutes your acceptance of the revised policy.
          </p>
        </section>

        <section className="policy-section">
          <h2>10. Contact Us</h2>
          <p>If you have questions or concerns about this Privacy Policy, please contact us:</p>
          <div className="policy-contact-block">
            <p><strong>Keystone Insurance Brokers Ltd</strong></p>
            <p>103-8077 King George Blvd, Surrey, BC, Canada V3W 5B4</p>
            <p>Phone: (604) 595-8666</p>
            <p>Email: <a href="mailto:Keystoneins@shaw.ca">Keystoneins@shaw.ca</a></p>
          </div>
        </section>
      </div>
    </div>
    </>
  );
}

export default Privacy;
